import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

type SideMenuStyleProps = {
  tab: number;
};

export const useSideMenuItemStyles = makeStyles<Theme, SideMenuStyleProps>(theme => ({
  icon: {
    minWidth: 32,
  },
  item: {
    paddingLeft: props => theme.spacing(2 * props.tab),
  },
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));
